import './style.scoped.css';
import Button from 'src/components/Button';
import { useHistory } from 'react-router-dom';
import Policy from 'src/models/Policy';
import { useTranslation } from 'react-i18next';
import { FunctionCode } from 'src/constants';
import paymentSt, { PaymentStore } from 'src/stores/PaymentStore';
import policyStore, { PolicyStore } from 'src/stores/PolicyStore';
import { observer } from 'mobx-react-lite';
import { featureInDevelopment } from 'src/utils';

interface PolicyModalObserverProps {
  show: boolean;
  onClose: () => void;
  policy: Policy;
  paymentStore?: PaymentStore;
  policyStore?: PolicyStore;
}

const PolicyModalObserver = observer((props : PolicyModalObserverProps) => {
  const { show, onClose, policy = {}, paymentStore } = props;
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <>
      <div className={(show ? "open " : "")+ "modal_view-mb"}>
        <div className="modal_view__overlay" onClick={() => onClose()}></div>
        <div className="modal_body-view">
          <div className="modal_body--inner">
            {policy?.function.includes(FunctionCode.PAYMENT) && <Button
                text={t('payment')}
                onClick={() => {
                  paymentStore.getPolicyPayment({
                    policyNum: policy.policyNum,
                    bgIndex: policy.bgIndex,
                    history
                  });
                }}
                extraClassName={'w-full'}
            />}

            {policy?.function.includes(FunctionCode.CHANGE) && <Button
                text={t('change_contract_info')}
                onClick={() => featureInDevelopment()}
                extraClassName={'w-full text-blue bg-white mt-1'}
            />}

            {policy?.function.includes(FunctionCode.CANCEL) && <Button
                text={t('cancel_contract')}
                onClick={() => policyStore.getPolicyToCancel({
                  policy: policy,
                  history
                })}
                extraClassName={'w-full text-red bg-white mt-1'}
            />}
          </div>
        </div>
      </div>
    </>
  );
});

const PolicyModal = (props) => <PolicyModalObserver {...props} paymentStore={paymentSt} />;
export default PolicyModal;
